module.exports = __webpack_public_path__ + "static/img/tutorial_cut.fd503a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation/img/tutorial_cut.png
// module id = LKql
// module chunks = 1